import React, { useState } from 'react';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import RoomList from './RoomList';
import SearchInput from './SearchInput';
import type { ChatRoom } from '../../types/chat';

interface MobileRoomListProps {
  rooms: ChatRoom[];
  isLoading?: boolean;
  onSelectRoom: (room: ChatRoom) => void;
  onNewChat: () => void;
}

const MobileRoomList: React.FC<MobileRoomListProps> = ({
  rooms,
  isLoading,
  onSelectRoom,
  onNewChat,
}) => {
  const [search, setSearch] = useState('');

  const filtered = search
    ? rooms.filter((r) => {
        const display = (r.name ?? '') + ' ' + (r.last_message_preview ?? '');
        return display.toLowerCase().includes(search.toLowerCase());
      })
    : rooms;

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 pt-4 pb-3 flex items-center justify-between gap-2">
        <h1 className="text-2xl font-bold text-text-primary">Chat</h1>
        <button
          type="button"
          onClick={onNewChat}
          aria-label="Start a new chat"
          className="p-2 rounded-full bg-primary-500 hover:bg-primary-600 dark:hover:bg-primary-400"
        >
          <UserPlusIcon className="w-5 h-5" />
        </button>
      </div>
      <div className="px-4 pb-3">
        <SearchInput value={search} onChange={setSearch} placeholder="Search contacts…" />
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin">
        <RoomList rooms={filtered} onSelect={onSelectRoom} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default MobileRoomList;
